import { useEffect, useRef } from "react";

import { Messages } from "@/components/General/Messages/messages.container";
import { withBreakpoints } from "@/utils/breakpoints/breakpoints.provider";

import { useWoosmap } from "./hooks/useWoosmap.hook";
import { StoreSearchComponent } from "./storeSearch.component";
import { StoreSearchContextProvider } from "./storeSearch.context";
import { StoreUrl } from "./storeSearch.types";

export type StoreSearchContainerProps = {
    storeUrls: Array<StoreUrl>;
    storeFeatures: Array<string>;
};

const StoreSearchContainer = ({
    storeUrls,
    storeFeatures
}: StoreSearchContainerProps) => {
    const mapElementRef = useRef<HTMLDivElement>(null);

    const {
        searchItem,
        selectedStore,
        handleUrl,
        stores,
        resetSearchItem,
        storesLoading
    } = useWoosmap({
        mapElementRef,
        storeUrls: storeUrls
    });

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        handleUrl();
    }, []);

    return (
        <StoreSearchContextProvider
            stores={stores}
            storesLoading={storesLoading}
            selectedStore={selectedStore}
            selectedSearchItem={searchItem}
            handleUrl={handleUrl}
            storeFeatures={storeFeatures}
            storeUrls={storeUrls}
            resetSearchItem={resetSearchItem}
        >
            <Messages messageid="storesearch-locator-error" />
            <StoreSearchComponent mapElementRef={mapElementRef} />
        </StoreSearchContextProvider>
    );
};

const StoreSearchSkeleton = () => (
    <article
        className={
            "tw:my-4 tw:h-[80vh] tw:max-h-200 tw:flex tw:rounded-md tw:bg-grey"
        }
    />
);

const StoreSearch = withBreakpoints(StoreSearchContainer, StoreSearchSkeleton);

export { StoreSearch };
